<template>
  <button @click="end">
    <template v-if="isLoading">
      加载中 {{ countdown }}S
    </template>
    <template v-else>
      继续上课
    </template>
  </button>
</template>
<script>
import { ref, computed } from '@vue/composition-api'
import { EXTRA_TIME } from './constant'
import getCountDown from './countdown'
export default {
  props: {
    // 是否添加额外的时长
    isExtraTime: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { root, refs, emit }) {
    const extraTime = computed(() => {
      const { isExtraTime } = props
      if (isExtraTime) {
        return EXTRA_TIME
      }
      return 0
    })
    const { countdown, start } = getCountDown()

    const isLoading = ref(false)
    function end() {
      const { isExtraTime } = props
      if (!isExtraTime) {
        emit('end')
        emit('realEnd')
        return
      }
      if (isLoading.value) {
        return
      }
      emit('end')
      // 额外添加时间 loadig 的倒计时
      isLoading.value = true
      start(extraTime.value, () => {
        emit('realEnd')
      })
    }
    return {
      countdown,
      end,
      isLoading
    }
  }
}
</script>
<style lang="less" scoped>
.btn-wrap {
  display: inline-block;
}
button {
  width: 106px;
  height: 48px;
  background: #3262fd;
  border: none;
  box-shadow: 0px 2px 4px rgba(70, 28, 255, 0.2), 0px 8px 16px rgba(67, 24, 255, 0.1);
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  margin-left: 16px;
  color: #fff;
}
</style>
